import { render, staticRenderFns } from "./ClientCollectionsArticleSelector.vue?vue&type=template&id=5cd5f36a&scoped=true"
import script from "./ClientCollectionsArticleSelector.vue?vue&type=script&lang=js"
export * from "./ClientCollectionsArticleSelector.vue?vue&type=script&lang=js"
import style0 from "./ClientCollectionsArticleSelector.vue?vue&type=style&index=0&id=5cd5f36a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd5f36a",
  null
  
)

export default component.exports